import { useEffect, useRef } from 'react';

/**
 * Custom hook to store the previous value of a variable.
 *
 * @param value - The current value you want to track.
 * @returns The previous value before the current render.
 */
export function usePrevious<T>(value: T): T | undefined {
  const ref = useRef<T>();

  useEffect(() => {
    ref.current = value;
  }, [value]);

  return ref.current;
}
